interface JWTOptions {
  [key: string]: any
  expiresIn: number
}

/**
 * 生成 Token
 *
 * @param {any} payload 数据
 * @param {string} secretKey 密钥
 * @returns {string} 用户 Token
 */
export function generateToken(
  payload: any,
  secretKey: string,
): string {
  const token = btoa(JSON.stringify({ data: payload, secretKey }))

  return token
}

/**
 * 从缓存获取用户 Token
 *
 * @param {string} [key] 缓存 Key
 * @returns {string} 用户 Token
 */
export function getToken(key: string = 'token'): string {
  return localStorage.getItem(key) ?? ''
}

/**
 * 保存用户 Token 到缓存
 *
 * @param {string} token 用户 Token
 * @param {string} [key] 缓存 Key
 */
export function saveToken(token: string, key: string = 'token'): void {
  localStorage.setItem(key, token)
}

/**
 * 删除 Token 缓存
 *
 * @param {string} [key] 缓存 Key
 */
export function clearToken(key: string = 'token'): void {
  localStorage.removeItem(key)
}
